import {createContext} from 'react';
import type {WorkflowStatus} from '../../types/filmWorkflow';
import type {WorkflowInitialReads} from './workflowPageLoadPolicy';
/** Page sở hữu status/poll; panel cũ độc lập vẫn có fallback. */
export const WorkflowPageStatusContext=createContext<{planId:string;status:WorkflowStatus|null;initialReads?:WorkflowInitialReads|null;refresh:()=>Promise<WorkflowStatus|null>}|null>(null);
